<template>
    <router-view/>
     <iframe src="./mms3D/index.html" frameborder="0" id="iframe"></iframe>
    <div class="header" v-show="show">
            <div class="title">
                <p>木棉树数字孪生变电站3D可视化系统</p>
                <span>Kapok tree substation visualization platform</span>
            </div>
            <ul class="time-list">
                <li><span>温度</span>22℃ <i></i></li>
                <li>天气 <b></b> <i></i> </li>
                <li>{{year}} <i></i> </li>
                <li>{{data}}</li>
            </ul>
        </div>


    <ul class="btn-box" :style="'right:'+right">
        <li v-for="(item,i) in bglist" :key="i" :style="'background: url('+item.bg+')'" @click="cahnge(i)" v-show="item.toggle"></li>

    </ul>


    <div class='top-bg' v-show="show"></div>


    <div class='left-bg' v-show="show"></div>


    <div class='right-bg' v-show="show"></div>

</template>
<script>
    import moment from "moment";
    import {reactive,ref} from 'vue';

    export default {
        name: "App",
        setup() {
        	var right = ref('0%');
           var bglist = reactive([
               {
                   active:0,
                   bg:require("./assets/dl.png"),
                   toggle:true
               },
               {
                   active:0,
                   bg:require("./assets/btn.png"),
                   toggle:false
               },
               {
                   active:0,
                   bg:require("./assets/jq.png"),
                   toggle:true
               }
           ]);
            var year = ref('');
            var data = ref('');
            var show = ref(false);
          
            const appShow = (flage)=>{
                show.value = flage;
//              alert(show.value)
                if(show.value){
                	right.value = '21%';
                }else{
                	right.value = '0%';
                }
            };
            window.appShow = appShow;
             const show1 = (flage)=>{
           	bglist[0].toggle = flage;
           	bglist[1].toggle = !flage;
           }
           window.show1 = show1;
            year.value = moment().format('YYYY年MM月DD日');
            setInterval(()=>{
                data.value = moment().format('H:mm:ss');
            },1000)
           const cahnge = (num)=>{
               if(num==0){

                   if(bglist[num].active==0){
                       bglist[num].bg = require("./assets/dl-active.png")
                       bglist[num].active = 1;
                       //电流选中
                   }else if(bglist[num].active==1){
                       bglist[num].bg = require("./assets/dl.png")
                       bglist[num].active = 0;
                       //电流取消
                   }
                document.getElementById("iframe").contentWindow.MMAPI.clickthings(0);
                   
               }else if(num==2){
                   if(bglist[num].active==0){
                       bglist[num].bg = require("./assets/jq-active.png")
                       bglist[num].active = 1;
                       //机器人选中
                   }else if(bglist[num].active==1){
                       bglist[num].bg = require("./assets/jq.png")
                       bglist[num].active = 0;
                       //机器人取消
                   }
                  document.getElementById("iframe").contentWindow.MMAPI.clickthings(1);
                   
               }else if(num==1){
               	//返回
               	document.getElementById("iframe").contentWindow.MMAPI.test2()
               }
           };
          
           return{
               bglist,
               cahnge,
               year,
               data,
               show,
               right
           }
        }
    }
</script>
<style lang="less">

    .top-bg{
        background: url("./assets/top-bg.png") no-repeat;
        background-size: 100% 100%;
        width: 100%;
        height: 8.9vh;
        position: absolute;
        top: 0;
        left: 0;
        pointer-events: none;
    }
    .left-bg{
        background: url("./assets/left-bg.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        width: 399px;
        height: 100%;
        top: 0;
        left: 0;
        pointer-events: none;
    }
    .right-bg{
        background: url("./assets/right-bg.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        right: 0;
        width: 387px;
        height: 100%;
        pointer-events: none;
    }
    .title1{
        background: url("./assets/title.png") no-repeat;
        background-size: 100% 100%;
        width: 232px;
        height: 4.17vh;/*no*/
        position: relative;

        p{
            font-size: 24px;
            color: #fff;
            font-family: cn;
            position: absolute;
            left: 5%;
        }
        .title-info{
            width: 202px;
            height: 1.66vh;
            background: #1a8379;
            position: absolute;
            bottom: -30%;
            left: 5%;
            display: flex;
            align-items: center;
            padding-left: 5px;
            box-sizing: border-box;
            font-size: 12px;
            color: #fff;
            font-family: cn;
        }
    }
    #iframe {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
    }
    body{
        /*background: url("./assets/bg.png") no-repeat;*/
        /*background-size: 100% 100%;*/
    }
    * {
        margin: 0;
        padding: 0;
    }
    ul {
        list-style: none;
    }
    @font-face {
        font-family: zygb;
        src: url(./assets/fonts/ZhenyanGB.TTF);
    }
    @font-face {
        font-family: cn;
        src: url(./assets/fonts/cn.OTF);
    }
    .header{
        width: 100%;
        height: 5vh;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 20px;
        padding-top: 1.85vh;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
        .title{
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            font-family: zygb;
            p{
                font-size: 30px;
                color: #fff;
            }
            span{
                font-size: 12.5px;
                color: #fff;
            }
        }
        .time-list{
            display: flex;
            font-size: 16px;
            font-family: cn;
            color: #fff;
            li{
                display: flex;
                align-items: center;
                span{
                    margin-right: 10px;
                }
                b{
                    background: url("./assets/dy.png") no-repeat;
                    background-size: 100% 100%;
                    width: 24px;/*no*/
                    height: 18px;/*no*/
                    margin-left: 8px;
                }
                i{
                    margin: 0 10px;
                    display: block;
                    height: 12px;
                    width: 1px;
                    background: #fff;
                }
            }
        }
    }
    .btn-box{
        position: absolute;
        right: 0%;
        /*
         * 21
         */
        top: 9%;
        transition: all 0.8s;
        li{
            width: 46px;/*no*/
            height: 58px;/*no*/
            background: url("./assets/dl.png") no-repeat;
            background-size: 100% 100%!important;
            margin-bottom: 15px;/*no*/
            cursor: pointer;
        }

    }
</style>
